import React, {Component} from "react";

import "./Source.css";

class Source extends Component {

  render() {
    const {text} = this.props;
    return (
      <div className="fow-source">
        <span className="fow-source-label fow-font-text fow-font-size-sm">{text}</span>
      </div>
    );
  }
}

export default Source;
